import { render, staticRenderFns } from "./VerifiedPhotosPage.vue?vue&type=template&id=45221471&scoped=true"
import script from "./VerifiedPhotosPage.vue?vue&type=script&lang=js"
export * from "./VerifiedPhotosPage.vue?vue&type=script&lang=js"
import style0 from "./VerifiedPhotosPage.vue?vue&type=style&index=0&id=45221471&lang=scss&scoped=true"
import style1 from "./VerifiedPhotosPage.vue?vue&type=style&index=1&id=45221471&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45221471",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45221471')) {
      api.createRecord('45221471', component.options)
    } else {
      api.reload('45221471', component.options)
    }
    module.hot.accept("./VerifiedPhotosPage.vue?vue&type=template&id=45221471&scoped=true", function () {
      api.rerender('45221471', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/attendances/verifiedPhotos/VerifiedPhotosPage.vue"
export default component.exports